export default __webpack_public_path__ + "static/media/media_type_pdf.805db928.svg";